import React from 'react'
import Projects from '../components/projects/Projects'

const ProjectsPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-4 pt-24 pb-12">
      <Projects showAll={true} />
    </div>
  )
}

export default ProjectsPage
